export const rfidCardsResource = {
  name: 'RFID 卡片',
  fields: {
    id: 'ID',
    cardNumber: '卡片編號',
    cardUid: '卡片 UID',
    cardType: '卡片類型',
    user: '用戶',
    userId: '用戶',
    userName: '用戶名稱',
    userType: '用戶類型',
    vendor: '商戶',
    vendorId: '商戶',
    vendorName: '商戶名稱',
    allowedSites: '允許場地',
    assignedSites: '分配的場地',
    status: '狀態',
    isActive: '啟用',
    issuedDate: '發行日期',
    expiryDate: '到期日期',
    lastUsed: '最後使用',
    lastUsedAt: '最後使用時間',
    lastUsedSite: '最後使用場地',
    usageCount: '使用次數',
    totalKwh: '總 kWh',
    createdAt: '創建時間',
    updatedAt: '更新時間',
  },
  types: {
    standard: '標準',
    admin: '管理員',
    guest: '訪客',
    fleet: '車隊',
  },
  sections: {
    cardInfo: '卡片資訊',
    assignment: '分配',
    siteAccess: '場地訪問',
    settings: '設定',
    usageHistory: '使用歷史',
  },
  validation: {
    cardNumberFormat: '只能包含十六進制字符 (0-9, A-F)',
  },
  siteCount: '個場地',
  list: {
    subtitle: '管理 RFID 卡片和場地分配',
    filters: {
      search: '按卡片編號、用戶或商戶搜尋',
    },
  },
  create: {
    title: '創建 RFID 卡片',
    subtitle: '註冊新的 RFID 卡片',
    infoMessage: 'RFID 卡片允許員工在充電站進行身份驗證。每張卡片必須分配給用戶和商戶。',
    cardNumberHelperText: 'RFID 卡片上印刷的唯一識別碼（十六進制格式）',
    cardTypeHelperText: '選擇此卡片提供的訪問類型',
    vendorHelperText: '選擇管理此卡片的商戶/公司',
    userHelperText: '選擇將使用此卡片的員工',
    selectVendorFirst: '請先選擇商戶以查看可用場地',
    noSitesAvailable: '所選商戶未分配任何場地',
    noUsersAvailable: '此商戶沒有可用的 RFID 用戶',
    siteSelectionHelp: '選擇此卡片可以訪問的場地。如果未選擇任何場地，該卡片將可以訪問所有供應商場地。',
    searchSites: '搜尋並選擇場地...',
    usageInfo: '卡片使用',
    usageHelperText: '創建後，此卡片可立即在任何分配的充電站使用。使用歷史和統計數據將自動跟踪。',
  },
  edit: {
    title: '編輯 RFID 卡片',
    subtitle: '更新 RFID 卡片資訊',
    infoMessage: '管理 RFID 卡片詳情和訪問權限。更改立即生效。',
    cardNumberHelperText: '卡片編號創建後無法更改',
    cardTypeHelperText: '選擇此卡片提供的訪問類型',
    vendorHelperText: '商戶創建後無法更改',
    userHelperText: '選擇將使用此卡片的員工',
    noSitesAvailable: '所選商戶未分配任何場地',
    siteSelectionHelp: '選擇此卡片可以訪問的場地。如果未選擇任何場地，該卡片將可以訪問所有供應商場地。',
    searchSites: '搜尋並選擇場地...',
    assignmentHelperText: '商戶和用戶分配創建後無法更改。如需重新分配，請創建新卡片。',
    deactivateWarning: '停用此卡片將立即阻止其在充電站使用。',
  },
  show: {
    title: 'RFID 卡片詳情',
    subtitle: '檢視 RFID 卡片詳情',
    tabs: {
      details: '詳細資料',
      chargingHistory: '充電歷史',
    },
    noChargingHistory: '此卡片沒有充電時段記錄。',
    columns: {
      session: '時段',
      startTime: '開始時間',
      site: '站點',
      charger: '充電器',
      energy: '電量',
      cost: '費用',
    },
  },
  status: {
    active: '啟用',
    suspended: '暫停',
    expired: '已過期',
    lost: '遺失',
  },
  cardType: {
    mifare_classic: 'MIFARE Classic',
    mifare_desfire: 'MIFARE DESFire',
    ntag: 'NTAG',
    other: '其他',
  },
  userType: {
    app: '應用用戶',
    rfid: '純 RFID',
  },
  actions: {
    bulkImport: '批量匯入',
    bulkExport: '匯出卡片',
    suspend: '暫停卡片',
    activate: '啟用卡片',
    assignSites: '分配場地',
  },
};

export const rfidCards = {
  'rfid-cards': rfidCardsResource,
};